const routes = [
    {
        path: "/system/images",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
